import { useCallback } from "react"
import { ApiBalanceParams, getEvmBalance } from "services/commonServices"

const useTools = () => {
    const getBalanceForEvm = useCallback(async (chainName: string, contractAddress: string, userAddress: string) => {
        if(!(chainName || contractAddress || userAddress)) return '0.0'
        const params : ApiBalanceParams = {
            chain: chainName,
            address: userAddress,
            contractAddress: contractAddress
        }
        const balance = await getEvmBalance(params)
        return balance
    }, [])

    return {
        getBalanceForEvm
    }
}

export default useTools